module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Johnny-English-Strikes-Again.b3491bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Johnny-English-Strikes-Again.jpg
// module id = Xnn2
// module chunks = 0